import { Badge } from "@/components/ui/badge";
import { countries } from "@/constants/countries";
import clsx from "clsx";

type Props = {
  country: string;
  className?: string;
};

export const CountryBadge = ({ country, className }: Props) => {
  const countryData = countries.find((c) => c.countryCode === country);

  return (
    <Badge variant="secondary" className={clsx("gap-2 text-sm", className)}>
      {countryData && (
        <img
          src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${country.toUpperCase()}.svg`}
          className="h-6 w-6"
        />
      )}
      {countryData?.label_fr || country}
    </Badge>
  );
};
